import { createDomain } from 'effector';

export const RootDomain = createDomain();
export const clearStores = RootDomain.event();

RootDomain.onCreateStore((store) => {
	store.reset(clearStores);
});
